import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from "./config"; 
function Checkin() {
  const navigate = useNavigate();

  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState('');
  const [message, setMessage] = useState('');

  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    if (!user) navigate('/');
  }, [user, navigate]);

  useEffect(() => {
    fetch(`${API_BASE}/api/groups/open`)
      .then(res => res.json())
      .then(data => setGroups(data));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    const res = await fetch(`${API_BASE}/api/checkin`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: user.user_id,
        Group_Name: selectedGroup
      })
    });

    const data = await res.json();

    if (!res.ok) {
      setMessage(data.message);
      return;
    }

    setMessage('✅ Check-in สำเร็จ');
    setSelectedGroup('');
  };

  if (!user) return null;

  return (
    <div style={{ padding: 40 }}>
      <h2>Check-in Group</h2>

      <form onSubmit={handleSubmit}>
        <select
          value={selectedGroup}
          onChange={(e) => setSelectedGroup(e.target.value)}
          required
        >
          <option value="">-- เลือก Group --</option>
          {groups.map(g => (
            <option key={g.id} value={g.Group_Name}>
              {g.Group_Name}
            </option>
          ))}
        </select>

        <br /><br />
        <button>Check-in</button>
      </form>

      <br />
      {message && <p>{message}</p>}

      <br />
      <button onClick={() => navigate('/profile')}>
        กลับหน้า Profile
      </button>
    </div>
  );
}

export default Checkin;
